<template>
  <span>
    <b-dropdown size="sm" :variant="currentStatus.color" :disabled="saving">
      <template slot="button-content">
        <i class="fa fa-spinner fa-spin mr-1" v-if="saving"></i>
        {{currentStatus.label}}
      </template>

      <b-dropdown-item v-for="status in selectableStatuses" :key="status.id" :class="`bg-${status.color}`" style="color: #fff !important;" @click="updateStatus(status.id)">{{status.label}}</b-dropdown-item>
    </b-dropdown>

    <text-alert :alert.sync="alert" class="ml-1"></text-alert>
  </span>
</template>

<script>
export default {
  props: {
    order: Object
  },
  data () {
    return {
      saving: false,
      alert: false
    }
  },
  computed: {
    status () {
      return this.order.status
    },
    statuses () {
      return [
        { id: 'processing', label: 'Klaar om te picken', color: 'danger' },
        { id: 'picked', label: 'Gepickt', color: 'info' },
        { id: 'completed', label: 'Voltooid', color: 'success' },
        { id: 'on-hold', label: 'On hold', color: 'warning' },
        { id: 'cancelled', label: 'Geannuleerd', color: 'secondary' },
        { id: 'pending-payment', label: 'Wachten op betaling', color: 'secondary', selectable: false },
        { id: 'refunded', label: 'Geretourneerd', color: 'secondary', selectable: false },
        { id: 'failed', label: 'Mislukt', color: 'secondary', selectable: false }
      ]
    },
    currentStatus () {
      return this.statuses.find(s => s.id === this.status)
    },
    selectableStatuses () {
      return this.statuses.filter(s => s.selectable !== false)
    }
  },
  methods: {
    updateStatus (newStatus) {
      const oldStatus = this.order.status
      this.order.status = newStatus

      const data = {
        status: newStatus
      }

      this.saving = true
      this.$http.patch(`/orders/${this.order.id}`, data)
        .then((response) => {
          this.saving = false
          this.alert = { variant: 'success', message: 'Opgeslagen' }
        })
        .catch(() => {
          this.saving = false
          this.order.status = oldStatus
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het opslaan van de status. Probeer het opnieuw.`, 'error')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderStatusBadge.vue?7545866d